// Class strings only the import pages use (the shared ones are in `catalog/components/styles`). Plain Tailwind utilities with semantic tokens.

/** Raw text from a file: it keeps its white space, so a cell that gets trimmed shows the difference, and a long value wraps. */
export const rawText = "whitespace-pre-wrap [overflow-wrap:anywhere]";

/** A value that is empty in the file or in the proposal. */
export const emptyValue = "text-muted-foreground italic";

/** A checksum or another long machine value. */
export const monoValue = "font-mono text-sm [overflow-wrap:anywhere]";

/** The link-looking button that jumps to a column. */
export const linkButton =
  "h-auto min-h-11 justify-start p-0 text-left text-base whitespace-normal compact:h-auto compact:min-h-8";

/** A wrapping row of the buttons that end a step. */
export const stepActions = "flex flex-wrap gap-2";
